module.exports = __webpack_public_path__ + "static/img/robot-avatar.b69b1bdd.png";